<template>
  <div class="pa-10">
    <title-page icon="mdi-file-chart-outline">
      {{ $t('reports.usages.usages') }}
    </title-page>

    <v-breadcrumbs
        :items="[
            {text: $t('reports.reports'), to: {name: 'reports'}, exact: true},
            {text: $t('reports.usages.usages')},
        ]"
        divider=">"
    ></v-breadcrumbs>

    <report-usages-list />

  </div>
</template>

<script>

import ReportUsagesList from "@/components/elements/ReportUsagesList.vue";

export default {
  components: {
    ReportUsagesList,
  },
  data() {
    return {

    }
  },

  mounted() {

  },

  watch: {

  },


  computed: {

  },


  methods: {



  }
}
</script>

<style lang="scss">

</style>